import { create } from 'zustand';

export const SIDEBAR_EXPAND_KEY = 'mario-sidebar-expand';

function getStoredSidebarExpand(): boolean {
  if (typeof localStorage === 'undefined') return true;
  const v = localStorage.getItem(SIDEBAR_EXPAND_KEY);
  return v === null ? true : v === 'true';
}

interface LayoutState {
  sidebarExpand: boolean;
  setSidebarExpand: (expand: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  sidebarExpand: getStoredSidebarExpand(),

  setSidebarExpand: (expand) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(SIDEBAR_EXPAND_KEY, String(expand));
    }
    set({ sidebarExpand: expand });
  },
}));

export default useLayoutStore;
